import { useQuery } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { Label } from '~/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '~/components/ui/select'
import { GQL_GROUPS } from '~/gql/groups/groups'

/**
 * Valeur sentinelle du choix « aucun groupe » : Radix Select refuse un
 * `SelectItem` de valeur vide, qu'il réserve à l'état non renseigné.
 */
const NO_GROUP = '__none__'

type IProps = {
  id: string
  value: string
  onChange: (groupName: string) => void
}

/**
 * Groupe de rattachement d'un compte créé, désigné par son NOM : c'est le champ
 * que portent la création unitaire et l'import CSV (#135). Vide = aucun groupe.
 */
function GroupNameSelect({ id, value, onChange }: IProps) {
  const { t } = useTranslation()
  const { data } = useQuery(GQL_GROUPS)

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{t('common.group')}</Label>
      <Select value={value || NO_GROUP} onValueChange={next => onChange(next === NO_GROUP ? '' : next)}>
        <SelectTrigger id={id}>
          <SelectValue placeholder={t('groups.none')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NO_GROUP}>{t('groups.none')}</SelectItem>
          {data?.groups.map(group => (
            <SelectItem key={group.id} value={group.name}>
              {group.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default GroupNameSelect
